import styled from 'styled-components';
import { THEME } from '../../../../../../../themes';
import { Body2Font } from '../../../../../../../themes/fonts';
import { hexToRgbA } from '../../../../../../../utils/colors';

interface ImageContainerProps {
  backgroundColor?: string,
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${THEME.SPACING.TINY};
  margin-top: ${THEME.SPACING.TINY};
  color: ${hexToRgbA(THEME.COLORS.PRIMARY_DARK, THEME.OPACITY.MED)};
`;

export const ImageWrapper = styled.div<ImageContainerProps>`
  border-radius: ${THEME.RADIUS.ROUNDISH};
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
`;

export const Wrapper = styled.div`
  flex: 1;
`;

export const Description = styled.div`
  ${Body2Font};
  font-weight: 300;
`;

export const CompanyTrendContainer = styled.div`
  width: 100%;
`;
